const BASE = process.env.REACT_APP_API_BASE || '/api';

async function request(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(body.error || 'Request failed');
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return body;
}

export const createCheckoutSession = (payload) =>
  request('/checkout', { method: 'POST', body: JSON.stringify(payload) });

export const getOrder = (orderId) =>
  request(`/order/${encodeURIComponent(orderId)}`);

export const createMembershipCheckout = (payload) =>
  request('/membership/checkout', { method: 'POST', body: JSON.stringify(payload) });

export const getMembership = (membershipId) =>
  request(`/membership/${encodeURIComponent(membershipId)}`);

export const activateMembershipTrip = (payload) =>
  request('/membership/activate', { method: 'POST', body: JSON.stringify(payload) });
